export default {
  metadata: {
    version: '1.0.0',
    id: 'footer-links-1.0.0',
    name: 'JDSFooterLinks',
    platform: 'web'
  },
  hierarchy: {
    container: [
      'title-jds-text',
      {
        'links-container': [
          {
            'link-item-container': ['jds_link']
          }
        ]
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{f_0}',
      'align-items': '{f_1}',
      size: '{f_2}'
    },
    'link-item-container': {
      size: '{f_3}',
      'padding-top': '{f_4}',
      'padding-bottom': '{f_5}',
      'flex-direction': '{f_6}',
      'justify-content': '{f_7}',
      'align-items': '{f_8}',
      'background-color': '{f_9}',
      behavior: {
        hover: {
          'background-color': '{f_10}'
        }
      }
    },
    'links-container': {
      'padding-top': '{f_13}',
      size: '{f_14}',
      'flex-direction': '{f_15}'
    },
    jds_link: {
      kind: 'submenu',
      textAppearance: 'body_s'
    },
    'title-jds-text': {
      'font-family': '{text_91}',
      color: '{text_20}',
      'font-size': '{text_90}',
      'line-height': '{text_92}',
      'letter-spacing': '{text_93}',
      'font-weight': '{text_94}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'padding-top': '{f_11}',
      'padding-bottom': '{f_12}'
    }
  },
  api: {
    config: {},
    data: {
      'links-container': {
        value: {
          name: 'links',
          type: 'list',
          object: {
            newTab: 'boolean',
            href: 'string',
            title: 'string',
            routerLinkProps: 'object',
            onClick: 'event'
          }
        }
      },
      jds_link: {
        title: {
          type: 'string',
          name: 'links.title'
        },
        href: {
          type: 'string',
          name: 'links.href'
        },
        newTab: {
          type: 'string',
          name: 'links.newTab',
          platform: 'web'
        },
        routerLinkProps: {
          type: 'RouterLinkProps',
          name: 'links.routerLinkProps',
          platform: 'angular'
        },
        provider: {
          type: 'object',
          name: 'links.provider',
          platform: 'react'
        },
        onClick: {
          type: 'string',
          name: 'links.onClick'
        }
      },
      'title-jds-text': {
        value: {
          type: 'string',
          name: 'title'
        }
      }
    },
    a11y: {
      'links-container': {
        name: 'links',
        repeating: {
          ariaLabel: 'linkAriaLabel',
          ariaDescribedby: {
            name: 'linkAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_link: {
        properties: {
          ariaLabel: 'links.linkAriaLabel',
          ariaDescribedby: 'links.linkAriaDescribedby'
        }
      }
    }
  }
};
